import { ProductCorban } from "./corban.model";
import { Processor } from "./processor.model";
import { SelfService } from "./SelfService";

export type Product = {
  id?: string;
  name: string;
  type: ProductType;
  percentage: number;
  partnerPercentage?: number | null;
  minLimit?: number | null;
  maxLimit?: number | null;
  enabled: boolean;
  createdAt?: Date;
  ProductCorbans?: ProductCorban[];
  processorId?: string | null;
  processor?: Processor | null;
  SelfServices?: SelfService[];
};

export enum ProductType {
    RANGE = 'RANGE',
    LEVEL = 'LEVEL'
  };